module.exports = __webpack_public_path__ + "static/media/tuya.50b360b9.svg";